import React from "react";
import FloatingWhats from "../Components/FloatingWhats.jsx";
import Header from "../Components/Header.jsx";
import Footer from "../Components/Footer.jsx";
import BottomBar from "../Components/BottomBar.jsx";
import styles from "../styles/Assistencia.css";
import { Button } from "@mui/material";

const Assistencia = () => {
    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">Assistência<br/>Técnica</h1>
                            <img className="bannerInterno-img" src="../images/caminhao-assTec.png" alt="Banner Assitência-Técnica"/>
                        </div>
                    </div>
                </div>
                <div className="abrangencia">
                    <div className="abrangencia-content">
                        <div className="abrangencia-left from-left">
                            <h3 className="abrangencia-subtitle from-left">Assistência Técnica</h3>
                            <h2 className="abrangencia-title from-left">Atendimento em todo o Brasil!</h2>
                            <div className="abrangencia-textBox from-left">
                                <div className="abrangencia-bar"/>
                                <div className="abrangencia-text">
                                    <p className="abrangencia-textContent">A Balanças Cuiabá é referência nacional no seguimento de Assistência técnica e manutenção em sistemas de pesagens. Com mais de 25 anos atuando no mercado de assistência técnica.</p>
                                    <p className="abrangencia-textContent">Quando o assunto é assistência técnica e manutenção de balanças rodoviárias, ferroviárias e industriais das mais diferentes marcas e modelos existentes no mercado nacional, a empresa conta com uma rede de assistência técnica nas principais regiões produtoras de norte a sul do Brasil, equipada com frota de caminhão de peso padrão e de veículos para serviços e atendimentos emergenciais, tudo para garantir o melhor e mais ágil serviço aos seus clientes.</p>
                                    <div className="abrangencia-bottom">
                                        <div className="abrangencia-pontos">
                                            <span className="abrangencia-ponto">+15</span>
                                            <span className="abrangencia-pontoText">pontos de atendimento em todo o Brasil!</span>
                                        </div>
                                        <span className="abrangencia-bottomText">Sempre um ponto perto de você!</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="abrangencia-right from-right">
                            <img src="../images/mapa-assTec.png" alt="Mapa de abrangência da assistência técnica" className="abrangencia-mapa"/>
                        </div>
                    </div>
                </div>
                <div className="horario-atendimento">
                    <div className="horario-atendimento-content from-bottom">
                        <h3 className="horario-atendimento-title">
                            <span style={{color:'#474747'}}>Horário de </span>
                            <span style={{color:'#9E1518'}}>Atendimento</span>
                        </h3>
                        <div className="horario-atendimento-bar"/>
                        <p className="horario-atendimento-text">
                            <span className="horario-atendimento-line1">De segunda à sexta-feira</span>
                            <span className="horario-atendimento-line2">08:00 às 12h | 13h às 17:48</span>
                        </p>
                        <span className="horario-atendimento-line3">Não atendemos aos<br/>sábados e domingos!</span>
                    </div>
                </div>
                <div className="home2">
                    <div className="home2-content2">
                        <div className="home2-left from-right">
                            <img className='home2-left-img' src='../images/preventiva.png'/>
                        </div>
                        <div className="home2-right from-left">
                            <h1 className='home1-title from-left'>
                                <span style={{fontWeight:500}}>MANUTENÇÃO </span><span style={{fontStyle:'italic'}}>PREVENTIVA</span>
                            </h1>
                            <p className="preventiva-text from-left">Efetuada com a intenção de reduzir a probabilidade de falhade uma máquina ou equipamento. É uma intervenção programada antes da data provável do aparecimento de uma falha, sendo, um conjunto de serviços de inspeções sistemáticas, ajustes conservação e eliminação de defeitos, visando a evitar falhas, realizado por técnicos capacitados e credenciados junto ao INMETRO.</p>
                            <div className="home2-topics from-left">
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/preventiva1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Reduz paradas inesperadas e evita prejuízos operacionais.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/preventiva2.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Aumenta a vida útil dos equipamentos.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/preventiva3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Mantém a balança dentro das exigências do INMETRO.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                    <div className="home2-content1">
                        <div className="home2-left from-left">
                            <img className='home2-left-img' src='../images/corretiva.png'/>
                        </div>
                        <div className="home2-right">
                            <h1 className='home1-title from-right'>
                                <span style={{fontWeight:500}}>MANUTENÇÃO </span><span style={{fontStyle:'italic'}}>CORRETIVA</span>
                            </h1>
                            <p className="preventiva-text from-right">Manutenção que consiste em substituir peças ou componentes que se desgataram ou falharam e que levaram o equipamento a uma parada não programada, por falha ou pane em um ou mais componentes. É o conjunto de serviços executados nos equipamentos com falha, sem planejamento e em carater emergencial.</p>
                            <div className="home2-topics from-right">
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/corretiva1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Proteção garantida contra raios, descargas elétricas, inundação, barro e poeira com a tecnologia Mettler Toledo.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/corretiva2.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Redução de manutenção em até 50%, trazendo mais confiabilidade e durabilidade do equipamento, garantindo a funcionalidade da balança.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/corretiva3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Precisão 3x maior nas pesagens que as demais células de carga no mercado.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                    <div className="home2-content2">
                        <div className="home2-left from-right">
                            <img className='home2-left-img' src='../images/preditiva.png'/>
                        </div>
                        <div className="home2-right">
                            <h1 className='home1-title from-left'>
                                <span style={{fontWeight:500}}>MANUTENÇÃO </span><span style={{fontStyle:'italic'}}>PREDITIVA</span>
                            </h1>
                            <p className="preventiva-text from-left">É aquela que indica as condições reais de funcionamento de equipamentos, com base em dados que informam o seu desgaste natural ou por mau uso. Trata-se de um processo que prediz o tempo de vida útil dos componentes dos equipamentos e as condições para que esse tempo de vida seja bem aproveitado.</p>
                            <div className="home2-topics from-left">
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/preditiva1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Reduz paradas inesperadas e evita prejuízos operacionais.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/preditiva2.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Aumenta a vida útil dos equipamentos.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='../images/icons/preditiva3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Mantém a balança dentro das exigências do INMETRO.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="plantao">
                    <div className="plantao-content from-bottom">
                        <h3 className="plantao-title">
                            <span style={{color:'#474747'}}>Plantão </span>
                            <span style={{color:'#9E1518'}}>24h</span>
                        </h3>
                        <div className="horario-atendimento-bar from-bottom"/>
                        <p className="plantao-contatos from-bottom">
                            <a href="https://wa.me/+554591084120" style={{textDecoration:'none'}}>
                                <Button sx={{fontFamily:'Inter', overflow:'hidden', display:'flex', flexDirection:'column', height:'100px', width:'270px', borderRadius:'8px', color:'#FFF', textTransform:'none', backgroundColor:'#474747', fontWeight:'700', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>
                                    <span style={{fontStyle:'italic'}}>Cascavel/PR</span>
                                    <span style={{fontSize:'22px'}}>(45) 9108-4120</span>
                                    <img style={{position:'absolute', height:80, right:-14, opacity:0.3}} src="images/icons/whatsapp.svg"/>
                                </Button>
                            </a>
                            <a href="https://wa.me/+556599622632" style={{textDecoration:'none'}}>
                                <Button sx={{fontFamily:'Inter', overflow:'hidden', display:'flex', flexDirection:'column', height:'100px', width:'270px', borderRadius:'8px', color:'#FFF', textTransform:'none', backgroundColor:'#474747', fontWeight:'700', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>
                                    <span style={{fontStyle:'italic'}}>Cuiabá/MT</span>
                                    <span style={{fontSize:'22px'}}>(65) 9962-2632</span>
                                    <img style={{position:'absolute', height:80, right:-14, opacity:0.3}} src="images/icons/whatsapp.svg"/>
                                </Button>
                            </a>
                        </p>
                    </div>
                </div>
                <div className="procedimentos">
                    <div className="procedimentos-content">
                        <div className="procedimentos-top">
                            <img className="procedimentos-icon" src="images/icons/procedimentos.svg"/>
                            <div className="procedimentos-header">
                                <h4 className="procedimentos-subtitle">Lista de Procedimentos</h4>
                                <h2 className="procedimentos-title">Manutenção e Reformas</h2>
                            </div>
                        </div>
                        <div className="procedimentos-bar"/>
                        <div className="procedimentos-text">
                            <h3>PROCEDIMENTO DE MANUTENÇÃO – ELETROELETRONICA E MECÂNICA</h3>
                            <ul>
                                <li>Os serviços de <strong>manutenção eletroeletrônica e mecânica</strong> constituem-se das seguintes atividades:</li>
                                <li>Desmontagem do sistema oscilante de Células.</li>
                                <li>Desmontagem das Castanhas de Apoio inferior e Superior</li>
                                <li>Avaliação eletrônica das Células de Carga tais como:
                                    <ul>
                                        <li>Resistência de Entrada;</li>
                                        <li>Resistência de Saída;</li>
                                        <li>Tensão Nominal de Entrada;</li>
                                        <li>Nível Elétrico.</li>
                                    </ul>
                                </li>
                                <li>Limpeza de todo sistema oscilante, mecânico e articulações da balança.</li>
                                <li>Lubrificação das células de carga.</li>
                                <li>Conferir todas as regulagens mecânicas e batentes, juntamente com suas oscilações normais da balança.</li>
                                <li>Verificação da estrutura mecânica tais como:
                                    <ul>
                                        <li>Apertos das emendas do chassi (Caso aja);</li>
                                        <li>Nivelamento dos chassis – Somente na montagem inicial.</li>
                                    </ul>
                                </li>
                                <li>Oxidações dos conectores, dos sensores de peso, placa de junção e indicador de peso.</li>
                                <li>Verificação da caixa e placa de junção (Organização dos cabos).</li>
                                <li>Verificar todas as caixas de passagens (relacionadas a balança), tubulações e conexões da estrutura de pesagem até o indicador de pesagem.</li>
                                <li>Verificar a integridade dos cabos das células de carga bem como cabos de ligação Junção / Indicador de Peso.</li>
                                <li>Verificar presença de umidade nas tubulações metálicas dos cabos de células e conectores.</li>
                                <li>Verificar o exato posicionamento dos sensores de peso, tanto na vertical como na horizontal, pois isto influencia diretamente na confirmação de peso da balança.</li>
                                <li>Verificar os desgastes dos discos de apoio dos sensores de peso, juntamente com sua fixação na longarina da balança.</li>
                                <li>Verificar o nível das bases dos sensores de peso.</li>
                                <li>Verificar os discos isoladores dos sensores de peso.</li>
                                <li>Verificar os flanges de apoio inferiores e aperto das porcas de fixação.</li>
                                <li>Verificar interferência de rádios portáteis com indicador de peso.</li>
                                <li>Verificar cabo de comunicação com CPU e alimentação elétrica estabilizada com plug de aterramento da balança e CPU.</li>
                                <li>Verificar fonte de alimentação chaveada do indicador (caso tenha), e corrente continua na carcaça.</li>
                                <li>Limpeza das placas de comunicação com limpa contato.</li>
                            </ul>

                            <h3>CERTIFICAÇÕES</h3>
                            <ul>
                                <li>NR 33</li>
                                <li>NR 35</li>
                                <li>CERTIFICADO RBC – Rede Brasileira de Calibração</li>
                                <li>CERTIFICADO INMETRO</li>
                                <li>SELO REPARADO INMETRO ELACRE</li>
                            </ul>

                            <h3>EPI's</h3>
                            <p>É de responsabilidade da empresa contratada fornecer e manter os funcionários com os respectivos EPI'S/ EPC'S conforme a descrição cargo / função.</p>
                            <ul>
                                <li>Protetor Auricular</li>
                                <li>Óculos de proteção de lentes claras e escuras</li>
                                <li>Capas de Chuva para todo o corpo</li>
                                <li>Faixa sinalizadora e cones</li>
                                <li>Luvas multi contato</li>
                                <li>Botas de borracha</li>
                                <li>Botinas de segurança</li>
                                <li>Capacetes com jugular</li>
                                <li>Mascaras pff-1</li>
                                <li>Bloqueador solar com filtro fp 30</li>
                                <li>OBS: Todos os EPI'S descritos acima deveram conter o número do C.A. descrito nos equipamentos.</li>
                            </ul>

                            <h3>EQUIPAMENTOS</h3>

                            <h4>4.1 - Unidade Móvel de Calibração</h4>
                            <ul>
                                <li>Especialmente projetada e construída para realizar trabalhos de calibração, a Unidade Móvel de Calibração é dotada de um sistema hidráulico que permite a movimentação (carregamento / descarregamento) dos pesos-padrão, dispensando assim a necessidade de mão de obra e de veículos auxiliares na execução dos serviços, além da realização dos testes de concentração e distribuição das cargas nos ajustes das seções.</li>
                                <li>Utiliza um total de 10.000 kg de pesos-padrão, devidamente calibrados, acreditado pelo INMETRO na RBC, otimizando o tempo necessário para a realização do serviço de calibração, além de substituir os custos referentes ao transporte de ida e volta dos pesos padrão.</li>
                            </ul>

                            <h4>4.2 – Caixa de Ferramentas</h4>
                            <p>O técnico deve possuir uma maleta de ferramentas completa onde a mesma deve conter todas as chaves utilizadas para intervenção na balança e equipamento elétrico eletrônico, mecânico e um nível vertical e horizontal para conferir os níveis dos sensores de peso. Faz-se necessário para intervenção em uma balança um macaco hidráulico de 20 toneladas em bom estado de conservação e com suas inspeções em dia.</p>
                        </div>
                    </div>
                </div>



                <BottomBar/>
                <Footer/>
            </div>
        </div>
        )
}
export default Assistencia;